import * as React from "react";
import { css } from "@emotion/react";
import { CruiseCabinCard } from "main/javascripts/components/cruise/CruiseCabinCard";
import { VesselCabinCategories } from "main/javascripts/constants/VesselCabinCategories";
import { Cruise } from "main/javascripts/types/cruise";
import { space } from "main/javascripts/styles/base/spaceStyle";

export interface IProps {
  vesselCabins: Cruise.VesselCabin[];
}

export const LpCruiseCabinList: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { vesselCabins } = props;
  const cabinRates = vesselCabins.map((cabin) => {
    return {
      cruiseUniqueId: "",
      cabinCode: cabin.cabinCode,
      cabinCategory: cabin.cabinCategory,
      priceCents: 0, // ratesが存在しない場合は全て0に設定している
      vesselCabin: cabin,
    };
  });

  const cabinRatesData = Object.keys(VesselCabinCategories).map((key) => {
    const category = VesselCabinCategories[key];
    return cabinRates.filter(
      (cabinRate) => cabinRate.cabinCategory === category
    );
  });

  return (
    <div css={cabinListStyle}>
      {cabinRatesData.map((cabinRates, index) => {
        if (!cabinRates || cabinRates.length === 0) {
          return null;
        }
        return (
          <CruiseCabinCard key={index} cabinRates={cabinRates} param={{}} />
        );
      })}
    </div>
  );
};

const cabinListStyle = css`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space.atom2x};
  padding: ${space.atom2x} ${space.atom} ${space.atom2x};
`;
